"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Steps_1 = __importDefault(require("./Steps"));
var Navigation_1 = __importDefault(require("./Navigation"));
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var MyLevel_1 = __importDefault(require("./MyLevel"));
var Tournaments_1 = __importDefault(require("./Tournaments"));
var NewGames_1 = __importDefault(require("./NewGames"));
var config_1 = require("./config");
var DailyDigestContent = function (_a) {
    var _b;
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var _c = (0, react_1.useState)(0), activeStep = _c[0], setStep = _c[1];
    var stepsCount = 3;
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeDigest = (0, react_1.useCallback)(function () {
        if (typeof window !== 'undefined')
            Lockr.set(config_1.DAILY_DIGEST_NOTIFICATION, new Date());
        closeWindow();
    }, [closeWindow]);
    var setNextStep = (0, react_1.useCallback)(function () {
        if (activeStep < stepsCount - 1)
            setStep(activeStep + 1);
    }, [activeStep, setStep]);
    var setPrevStep = (0, react_1.useCallback)(function () {
        if (activeStep < stepsCount && activeStep > 0)
            setStep(activeStep - 1);
    }, [activeStep, setStep]);
    var setActiveStep = (0, react_1.useCallback)(function (step) {
        setStep(step);
    }, [setStep]);
    var _d = (0, swr_hooks_1.usePlayerStatus)(), userPoints = _d.userPoints, nextLevelMin = _d.nextLevelMin, progressPercents = _d.progressPercents, currentLevelInfo = _d.currentLevelInfo, nextLevelInfo = _d.nextLevelInfo;
    var pointsToNextLevel = (0, react_1.useMemo)(function () {
        if (nextLevelMin && userPoints)
            return nextLevelMin - userPoints;
        return Number(nextLevelMin);
    }, [nextLevelMin, userPoints]);
    return (react_1.default.createElement(ui_components_2.Modal, { portalNodeId: "modal", width: "600px", height: "640px", onClose: closeDigest },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('today')),
            react_1.default.createElement(Steps_1.default, { step: activeStep, stepsCount: stepsCount, setActiveStep: setActiveStep }),
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) }, activeStep === 0 && (react_1.default.createElement(MyLevel_1.default, { currentLevelInfo: currentLevelInfo, progressPercents: progressPercents, nextLevelInfo: nextLevelInfo, pointsToNextLevel: pointsToNextLevel, image: (_b = nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.images) === null || _b === void 0 ? void 0 : _b.default }))),
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) }, activeStep === 1 && (react_1.default.createElement(Tournaments_1.default, { pointsToNextLevel: pointsToNextLevel, closeDigest: closeDigest }))),
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) }, activeStep === 2 && (react_1.default.createElement(NewGames_1.default, { closeDigest: closeDigest, gameCardPlaceholder: gameCardPlaceholder }))),
            react_1.default.createElement(Navigation_1.default, { step: activeStep, stepsCount: stepsCount, setNextStep: setNextStep, setPrevStep: setPrevStep, closeDigest: closeDigest }))));
};
exports.default = react_1.default.memo(DailyDigestContent);
